export const PRIVACY_CONTENT_ID = 'privacypolicy';
export const DATA_TERMS_CONTENT_ID = 'dataterms';
